import React from "react";
import CloseBtn from "../CloseBtn";
import styled, {createGlobalStyle} from "styled-components";
import DetailButton from "./NextBtn";
import {BE_ADDR} from "../../../api/host"

const GlobalStyle = createGlobalStyle`
  body, html {
    background-color: #000;
  }
`

const BannerMainBlock = styled.div`
  background-color: #000;
  height: 100vh;
  box-sizing: border-box;
  padding: 0 20px;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: ${props => props.imgCover ? "cover" : "auto"};
  background-image: url("${props => `${BE_ADDR}${props.img.source_desktop}`}");

  @media (max-width: 480px) {
    background-image: url("${props => `${BE_ADDR}${props.img.source_mobile}`}");
  }
`

const BannerImage = ({timer, nextFunc, value, detailHandler, timeoutHandler}) => {
  
    return (
        <>
            <GlobalStyle/>
            <BannerMainBlock imgCover={false} img={value}>
                <CloseBtn count={timer} clearDelay={nextFunc}/>
                <DetailButton func={detailHandler}/>  
            </BannerMainBlock>
        </>
    )
}

export default BannerImage